import React from 'react';
import { Card, CardBody, Col, Button, Spinner } from 'reactstrap';
import { getFileType } from "../../../../utils/file";

const Overview = ({ preRegistration, onPreview, onApprove, onReject,  approveLoading, rejectLoading    }) => {
    const isPending = preRegistration?.status === "En attente";

    return (
        <Col xl={3}>
            <Card>
                <CardBody>
                    <h5 className="fw-semibold mb-3">Documents</h5>

                    <table className="table table-sm">
                        <tbody>
                            {preRegistration?.files?.length ? (
                                preRegistration.files.map((file, index) => {
                                    const type = getFileType(file.file_name);

                                    return (
                                        <tr key={file.id || index}>
                                            <th style={{ width: 30 }}>
                                                {type === "pdf" && (
                                                    <i className="mdi mdi-file-pdf-box text-danger" />
                                                )}
                                                {type === "image" && (
                                                    <i className="mdi mdi-image text-success" />
                                                )}
                                            </th>
                                            <td>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{file.file_name}</span>

                                                    <Button
                                                        size="sm"
                                                        color="primary"
                                                        onClick={() => onPreview(file)}
                                                    >
                                                        Aperçu
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="2" className="text-muted text-center">
                                        Aucun fichier joint
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/*
                    {isPending && (
                        <div className="d-grid gap-2 mt-4">
                            <Button
                                color="success"
                                onClick={onApprove}
                            >
                                Approuver
                            </Button>

                            <Button
                                color="danger"
                                onClick={onReject}
                            >
                                Rejeter
                            </Button>
                        </div>
                    )}
                        */}

                        {isPending && (
                            <div className="d-grid gap-2 mt-4">
                                <Button
                                color="success"
                                onClick={onApprove}
                                disabled={approveLoading || rejectLoading}
                                >
                                {approveLoading ? (
                                    <>
                                    <Spinner size="sm" className="me-2" />
                                    Approbation...
                                    </>
                                ) : (
                                    "Approuver"
                                )}
                                </Button>

                                <Button
                                color="danger"
                                onClick={onReject}
                                disabled={approveLoading || rejectLoading}
                                >
                                {rejectLoading ? (
                                    <>
                                    <Spinner size="sm" className="me-2" />
                                    Rejet...
                                    </>
                                ) : (
                                    "Rejeter"
                                )}
                                </Button>
                            </div>
                            )}
                </CardBody>
            </Card>
        </Col>
    );
};

export default Overview;
